import { render, staticRenderFns } from "./MFAValidation.vue?vue&type=template&id=b520868a"
import script from "./MFAValidation.vue?vue&type=script&lang=js"
export * from "./MFAValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3254644805/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b520868a')) {
      api.createRecord('b520868a', component.options)
    } else {
      api.reload('b520868a', component.options)
    }
    module.hot.accept("./MFAValidation.vue?vue&type=template&id=b520868a", function () {
      api.rerender('b520868a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Login/MFAValidation.vue"
export default component.exports